<template>
  <List>
    <template v-slot:list-header>
      <nav class="navbar navbar-light bg-light">
        <div class="container-fluid">
          <div class="navbar-brand">Snippets</div>

          <div class="nav-item">
            <div v-b-modal="'add-snippet'" class="btn btn-outline-primary">
              <b-icon-plus></b-icon-plus>
            </div>
          </div>

          <Modal id="add-snippet">
            <template v-slot:header>
              Add snippet
            </template>

            <template v-slot:content="{ changed, close }">
              <Editor v-on="{ changed, saved: created(close) }"></Editor>
            </template>
          </Modal>
        </div>
      </nav>
    </template>

    <template v-slot:list-content>
      <KeyNav :keyLevel="1" :size="snippets ? snippets.length : 0" @selected="selectAtIndex">
        <template v-slot:default="{ preselected }">
          <div class="list-group">
            <router-link v-for="(snippet, index) in snippets" :key="snippet.id" class="list-group-item" :class="[{ 'list-group-item-dark': preselected === index }]" active-class="active" :to="{ name: 'snippet', params: { snippetId: snippet.id }}">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">{{ snippet.title }}</h5>
                <time-ago :datetime="snippet.updated_at" tag="small"></time-ago>
              </div>

              <small>Updated <time-ago refresh :datetime="snippet.updated_at"></time-ago></small>
            </router-link>
          </div>
        </template>
      </KeyNav>
    </template>

    <template v-slot:detail>
      <router-view></router-view>
    </template>
  </List>
</template>

<script>
  import gql from 'graphql-tag'
  
  import List from '../components/List';
  import TimeAgo from 'vue2-timeago'

  import Modal from '../components/Editor';
  import Editor from '../components/editors/Snippet';

  import KeyNav from '../components/KeyNav'

  const GET_SNIPPETS = gql`
    query GetSnippets {
      snippets(order_by: { created_at: desc }) {
        id
        title
        updated_at
      }
    }
  `

  export default {
    name: 'snippets',

    components: {
      List,
      TimeAgo,
      Modal,
      Editor,
      KeyNav
    },

    methods: {
      created(callback) {
        return function(snippet, { cache }) {
          const data = cache.readQuery({ query: GET_SNIPPETS });
          data.snippets.splice(0, 0, snippet);

          cache.writeQuery({
            query: GET_SNIPPETS,
            data
          })

          callback();
          this.$router.push({ name: 'snippet', params: { snippetId: snippet.id } })
        }.bind(this)
      },

      selectAtIndex(index) {
        const snippet = this.snippets[index];
        this.$router.push({ name: 'snippet', params: { snippetId: snippet.id } })
      }
    },
    
    apollo: {
      snippets: GET_SNIPPETS
    }
  }
</script>

<style scoped>
  .list-group .btn:last-child {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }
</style>